var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.label && _vm.label.length > 0 && _vm.labelIcon.length == 0)?_c('h4',{staticClass:"up-label pr-1"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),(_vm.labelIcon.length > 0)?_c('div',{class:`up-icon ${_vm.labelIcon}`},[_c('span',{staticClass:"up-tooltip"},[_vm._v(_vm._s(_vm.label))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }